import Application from "../../Application";
import { IReportingPeriodPermission } from "../../model/reporting/ReportingPeriodPermission";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class UpdateReportingPeriodPermissionInteractor {
  private application: Application;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async execute(
    applicantId: number,
    reportingPeriodPermission: IReportingPeriodPermission
  ) {
    return this.applicantService.updateApplicantReportingPeriodPermission(
      applicantId,
      reportingPeriodPermission
    );
  }
}
